/* eslint-disable import/prefer-default-export */
export function getSizeProp(sizes) {
  const [first] = sizes;
  // `sizes` is formatted like [300, 250], or [[300, 250], [300, 600]]
  if (Array.isArray(first) || Number.isInteger(first)) {
    return {
      slotSize: sizes
    };
  }
  // `sizes` is formatted like [{ viewport: [0, 0], sizes: [[300, 250], [300, 600]] }]
  return {
    sizeMapping: sizes
  };
}
